module.exports = __webpack_public_path__ + "static/media/menetlused.0bac2598.png";